<template>
<div>
    <div class="main" v-if="isShow == 1">
        <div class="bg">
            <div class="close" @click="close()">
                <img src="@/assets/img/close.png" alt="" />
            </div>
            <div class="show show1">
                <img class="img1" src="@/assets/img/zuanshi.png" alt="" />
                <p class="h1">恭喜您，获得VIP试用</p>
                <p class="h2">尊敬的用户，赠送您十次试用机会</p>
                <div class="tq tq1">
                    <img src="@/assets/img/huangguan.png" alt="" />
                    <p>VIP特权：查看企业信息</p>
                </div>
                <div class="tq tq2">
                    <img src="@/assets/img/huangguan.png" alt="" />
                    <p>VIP特权：获取企业联系方式</p>
                </div>
                <a href="javascript:;" class="start" @click="close()">开始试用</a>
            </div>
        </div>
    </div>
    <div class="main" v-if="isShow == 2">
        <div class="bg">
            <div class="close" @click="close()">
                <img src="@/assets/img/close.png" alt="" />
            </div>
            <div class="show show2">
                <p class="h1">VIP试用结束</p>
                <p class="h2">您的试用次数已用完</p>
                <p class="red" style="cursor: pointer;" @click="$router.push('/vip/buy')">立即购买vip</p>
                <p class="h5">无限次数据查询</p>
                <p class="h5">一键获取企业联系方式</p>
                <button @click="$router.push('/vip/buy')">立即购买</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            isShow: 0,
        };
    },
    computed: {},
    methods: {
        close() {
            this.isShow = 0;
        },
        isvipshow(state) {
            this.isShow = state
        }
    },
    created() {},
};
</script>

<style lang="less" scoped>
.main {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2001;

    .bg {
        width: 402px;
        height: 500px;
        overflow: hidden;

        .close {
            float: right;
        }

        .show {
            margin-top: 38px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;

            .img1 {
                margin: 16px auto 20px;
            }

            .h1 {
                font-size: 26px;
                font-weight: 600;
                color: #483314;
                padding-bottom: 10px;
            }

            .h2 {
                font-size: 16px;
                color: #85593e;
            }

            .tq {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 210px;

                p {
                    font-size: 14px;
                    color: #85593e;
                    padding-left: 10px;
                }
            }

            .tq1 {
                margin-top: 36px;
            }

            .tq2 {
                margin-top: 18px;
            }

            .start {
                margin: 70px 0 0;
                width: 257px;
                height: 48px;
                background-color: #f6d6b0;
                border-radius: 23px;
                display: block;
                font-size: 20px;
                font-weight: 600;
                color: #634824;
                text-align: center;
                line-height: 48px;
            }
        }

        .show1 {
            width: 373px;
            height: 363px;
            background: url("../assets/img/show1.png") no-repeat center center;
            background-size: cover;
        }

        .show2 {
            width: 352px;
            height: 414px;
            background: url("../assets/img/show2.png") no-repeat top center;
            border-radius: 20px;
            overflow: hidden;
            margin-top: 34px;

            .h1 {
                color: #ffffff;
                padding: 34px 0 2px 0;
            }

            .h2 {
                color: #ffffff;
            }

            .wx {
                width: 120px;
                margin-top: 50px;
            }

            .red {
                font-size: 20px;
                font-weight: 550;
                color: #ff4e00;
                margin-top: 96px;
                border-bottom: #ff4e00 1px solid;
                margin-bottom: 20px;
            }

            .h5 {
                font-size: 14px;
                // line-height: 22px;
                letter-spacing: 1px;
                color: #999999;
            }

            button {
                margin-top: 25px;
                width: 200px;
                height: 46px;
                border-radius: 23px;
                background: #3199ff;
                color: #fff;
                font-size: 17px;
            }
        }
    }
}
</style>
